<template>
  <div class="my-vacancies-page">
    <h1 class="my-vacancies-page__title">{{ $tMyVacancy('My vacancies') }}</h1>

<!--    <button-->
<!--      v-scroll-to="{ el: '#recommended', offset: -70 }"-->
<!--      class="d-none d-sm-flex my-vacancies-page__anchor base-btn base-btn&#45;&#45;green"-->
<!--      type="button"-->
<!--    >-->
<!--      <span>{{ $tMyVacancy('Watch recommended vacancies') }}</span>-->
<!--    </button>-->

    <div :style="{minHeight: noLists ? '0' :  null}"
         class="my-vacancies-page__tabs account-tabs">
      <BasePreloader v-if="pending"/>
      <div class="account-tabs__navs d-sm-none">
        <AccountTabsNavs
          class="account-tabs__navs-inner"
          :tabs="tabs"
          :current="currentTab"
          @change="setCurrentTab($event)"
        />
      </div>

      <AccountTabsNavsMob
        :tabs="tabs"
        :current="currentTab"
        @change="setCurrentTab($event)"/>

      <div v-if="responses.length || waiting.length || bookmarks.length"
           class="account-tabs__content">
        <transition name="fade"
                    mode="out-in">
          <div v-if="currentTab === 0"
               class="account-tabs__block  my-vacancies-page__items-list"
               :key="1">
            <AccountMyVacanciesItem
              v-for="(vacancy, vacancyIndex) in responses"
              :key="vacancyIndex"
              :data="vacancy"/>
          </div>

          <div v-else-if="currentTab === 1"
               class="account-tabs__block  my-vacancies-page__items-list"
               :key="2">
            <AccountMyVacanciesItem
              v-for="(vacancy, vacancyIndex) in waiting"
              for-response
              :key="vacancyIndex"
              :data="vacancy"
              @delete="unsubscribe($event)"/>
          </div>

          <div v-else-if="currentTab === 2"
               class="account-tabs__block  my-vacancies-page__items-list"
               :key="2">
            <AccountMyVacanciesItem
              v-for="(vacancy, vacancyIndex) in bookmarks"
              :key="vacancyIndex"
              plainVacancy
              isBookmarks
              @responded="onResponded(vacancyIndex)"
              @bookmark="onBookmark(vacancyIndex, $event)"
              :data="vacancy"/>

            <div class="account-tabs__btn-wrap">
              <button @click.prevent="onRespondOnAll"
                      class="account-tabs__btn  base-btn  base-btn--outline-green">
                <span>{{ $tMyVacancy('Respond on all') }}</span>
                <BaseSvg name="ico-arrow-light"
                         width="0.6rem"
                         height="1rem"/>
              </button>
            </div>

            <BasePreloader v-if="pendingRespondOnAll"/>
          </div>
        </transition>


        <Note :value="$tMyVacancy('While you are looking for vacancies, the employer checks your resume')"
              class="account-tabs__note"/>
      </div>
    </div>

    <AccountMyVacanciesRecommendation
      :data="recommended"
      @reload="reloadRecommended()"
    />

    <AccountMyVacanciesHelpTooltips
      v-if="windowSizeMixin.width <= 1023"
      is-fixed
      :current-id="1"
    />

    <AccountMyVacanciesWhatNextModal
      v-model="showPopup"
    />
  </div>
</template>

<script>
  import {http} from '@/axios';
  import windowSizeMixin from '@/mixins/windowSizeMixin';

  import AccountMyVacanciesItem from '@/components/myVacancies/AccountMyVacanciesItem';
  import AccountMyVacanciesWhatNextModal from '@/components/myVacancies/AccountMyVacanciesWhatNextModal';
  import AccountMyVacanciesRecommendation from '@/components/myVacancies/AccountMyVacanciesRecommendation';
  import AccountMyVacanciesHelpTooltips from '@/components/myVacancies/AccountMyVacanciesHelpTooltips';
  import {mapGetters, mapState} from "vuex"
  import AccountTabsNavs from '@/components/accountTabs/AccountTabsNavs'
  import AccountTabsNavsMob from '@/components/accountTabs/AccountTabsNavsMob'
  import Note from "../../components/Note"
  import respondOnAllBooked from "@/actions/respondOnAllBooked"

  export default {
    name: 'AccountMyVacanciesPage',
    mixins: [windowSizeMixin],

    components: {
      Note,
      AccountTabsNavsMob,
      AccountTabsNavs,
      AccountMyVacanciesRecommendation,
      AccountMyVacanciesWhatNextModal,
      AccountMyVacanciesItem,
      AccountMyVacanciesHelpTooltips
    },

    data: () => ({
      pending: false,
      pendingRespondOnAll: false,
      error: false,
      pendingRecommended: false,
      errorRecommended: false,

      recommended: null,
      responses: [],
      waiting: [],
      bookmarks: [],

      showPopup: false,
    }),

    computed: {
      ...mapState('user', [
        'openedInteractionId',
      ]),
      ...mapGetters('user', [
        'hasInteraction',
      ]),
      currentTab() {
        return parseFloat(this.$route.query.currentTab) || 0
      },
      tabs() {
        const tabs = [];

        tabs.push(
          this.responses.length ? {name: `${this.$tMyVacancy('My responses')} (${this.responses.length})`} : null
        );

        tabs.push(
          this.waiting.length ? {name: `${this.$tMyVacancy('I waiting to new places')} (${this.waiting.length})`} : null
        );

        tabs.push(
          this.bookmarks.length ? {name: `${this.$tMyVacancy('Bookmarks')} (${this.bookmarks.length})`} : null
        );

        return tabs;
      },
      noLists() {
        return !this.pending && !this.responses.length && !this.waiting.length
      }
    },

    methods: {
      setCurrentTab(tabIndex) {
        this.$router.push({
          query: {
            currentTab: tabIndex
          }
        })
      },
      load() {
        this.pending = true;
        this.error = null;

        return http.get(`api/cabinet/my-responses`).then(({data: {data}}) => {
          this.responses = data.responses_list;
          this.waiting = data.waiting_list;
          this.bookmarks = data.bookmarks_list;

          if (this.currentTab === 0 && !this.responses.length) {
            this.setCurrentTab(1)
          }

          if (this.currentTab === 1 && !this.waiting.length) {
            this.setCurrentTab(2)
          }

          if (this.currentTab === 2 && !this.bookmarks.length) {
            this.setCurrentTab(0)
          }
        }).catch((error) => {
          this.error = error.response && error.response.data.message || error.message;
        }).finally(() => {
          this.pending = false;
        });
      },

      loadRecommended() {
        this.pendingRecommended = true;
        this.errorRecommended = null;

        return http.get(`api/cabinet/get-recommend-job`).then(({data: {data}}) => {
          this.recommended = data;
        }).catch((error) => {
          this.errorRecommended = error.response && error.response.data.message || error.message;
        }).finally(() => {
          this.pendingRecommended = false;
        });
      },

      reloadRecommended() {
        if (!this.recommended || !this.recommended.ID) return;

        const id = this.recommended.ID;
        this.pendingRecommended = true;
        this.errorRecommended = null;
        this.recommended = null;

        return http.get(`api/cabinet/get-recommend-job?decline=${id}`).then(({data: {data}}) => {
          this.recommended = data;
        }).catch((error) => {
          this.errorRecommended = error.response && error.response.data.message || error.message;
        }).finally(() => {
          this.pendingRecommended = false;
        });
      },

      unsubscribe(id) {
        if (!id) return;

        const index = this.waiting.findIndex((data) => data.waiting_list_id === id);
        this.waiting.splice(index, 1);

        if (!this.waiting.length) this.setCurrentTab(0)

        return http.delete(`api/cabinet/remove-from-waiting-list/${id}`);
      },
      checkCanShowThisPage() {
        if (!this.hasInteraction) return

        this.$router.replace({
          name: 'account-interaction',
          params: {
            id: this.openedInteractionId
          }
        })
      },


      subscriberOnRefresh() {
        this.$store.dispatch('user/userPusher/createPusher')
        this.unSubscribeOnRefresh()

        const channel = this.$store.state.user.userPusher.channel

        channel.bind('my-vacancies-update', ({update}) => {
          if (update.status === 'PLEASE_REFRESH') {
            this.load()
          }
        })

        channel.bind('update-bookmarks', () => {
          this.load()
        })

        channel.bind('update-recommend-vacancies', () => {
          this.loadRecommended()
        })
      },
      unSubscribeOnRefresh() {
        const channel = this.$store.state.user.userPusher.channel
        if (!channel) return
        channel.unbind('my-vacancies-update')
        channel.unbind('update-bookmarks')
        channel.unbind('update-recommend-vacancies')
      },
      onBookmark(vacancyIndex) {
        this.$delete(this.bookmarks, vacancyIndex)
      },
      onResponded(vacancyIndex) {
        this.$set(this.bookmarks[vacancyIndex], 'sended', true)
        this.load()
      },
      onRespondOnAll() {
        this.pendingRespondOnAll = true

        respondOnAllBooked()
          .finally(() => {
            this.pendingRespondOnAll = false
          })
      }
    },

    watch: {
      hasInteraction() {
        this.checkCanShowThisPage()
      }
    },

    created() {
      this.checkCanShowThisPage()

      this.load();
      this.loadRecommended();
      this.subscriberOnRefresh()

      const route = this.$route
      if (route.query.showModalInfo === 'true') {
        this.showPopup = true
        const newRoute = {
          name: route.name,
          params: {...route.params},
          query: {...route.query}
        }
        delete newRoute.query.showModalInfo

        this.$router.replace(newRoute)
      }

      const vacancyIdFromRoute = this.$route.query.vacancy_id

      if(vacancyIdFromRoute) {
        this.$vModal.open('accept-invite', {
          resumeId: vacancyIdFromRoute
        })
      }
    },
    beforeDestroy() {
      this.unSubscribeOnRefresh()
    }
  };
</script>
